import apiConfig from '@apiConfig';
import { components } from '@api/api';
import http from '@core/http';
import { useData } from '@hooks/useData';

export type RecentSearchesResponseItem = components["schemas"]["RecentSearch"];
export type RecentSearchesResponse = RecentSearchesResponseItem[];

const fetchRecentSearches = async (): Promise<RecentSearchesResponse> => {
    try {
        const response = await http.get(apiConfig.get('recent searches'));
        return response;
    } catch {
        return [];
    }
};

export function createRecentSearches(text: RecentSearchesResponseItem['text']) {
    return http.post(apiConfig.get('create recent searches', { text }));
}

const useRecentSearches = () => {
    return useData([], fetchRecentSearches);
};

export default useRecentSearches;